import { YupSchema } from 'services/yup/types'
import { yupArray, yupIgnore, yupNumber, yupString } from 'services/yup'
import { mainProductVS } from './mainProduct'
import {
  areRulesNotOverlappingCFG,
  byRulePricingCommonVS,
  withCostAndPrice,
} from './by-rule-pricing/byRulePricing'
import { isNameUniqueCFG } from '../common'
import { withQuantityHintVS, withTimeBeforeAfterHintVS } from './hints'
import {
  ProfessionalPricingRuleSet,
  ProfessionalFigure,
} from 'services/api/entities/catalog/professional/types/internal/professional-models'

type ProfessionalShift = ProfessionalPricingRuleSet['shiftPricingRules'][number]

const pricingShiftVS: YupSchema<ProfessionalShift> = withCostAndPrice.shape({
  name: yupString().required(),
  hoursFrom: yupString().required(),
  hoursTo: yupString().required(),
})

const professionalByRulePricingVS: YupSchema<ProfessionalPricingRuleSet> =
  byRulePricingCommonVS.concat(withCostAndPrice).shape({
    shiftPricingRules: yupArray(pricingShiftVS).test(isNameUniqueCFG),
  })

export const professionalVS: YupSchema<ProfessionalFigure> = mainProductVS
  .concat(withQuantityHintVS)
  .concat(withTimeBeforeAfterHintVS)
  .shape({
    pricing: yupArray(professionalByRulePricingVS)
      .test(areRulesNotOverlappingCFG)
      .min(1),
    sectionName: yupIgnore(),
    section: yupNumber().required(),
  })
